import {Button} from "antd";
import {useState} from "react";
import {DatePicker as MobileDatePicker} from "antd-mobile";
import {PickerDate} from "antd-mobile/es/components/date-picker/util";
import {BrowserView, MobileView} from "react-device-detect";
import LuxonDatePicker from "./LuxonDatePicker";
import type { PickerProps } from 'antd/es/date-picker/generatePicker';
import {DateTime} from "luxon";

type LuxonDatePickerProps = PickerProps<DateTime>;

export default function AdaptiveDatePicker(props: LuxonDatePickerProps) {
  const [mobileVisible, setMobileVisible] = useState(false);

  const handleOnValueChange = (date: PickerDate) => {
    const dateTime = date ? DateTime.fromJSDate(date) : null;
    if (!dateTime) return;

    const dateString = dateTime ? dateTime.toFormat('YYYY-MM-DD') : '';
    props.onChange?.(dateTime, dateString);
  };

  const handleSetToday = () => {
    const today = DateTime.now();
    props.onChange?.(today, today.toFormat('YYYY-MM-DD'));
    setMobileVisible(false);
  }

  return (
    <>
      <BrowserView>
        <LuxonDatePicker {...props} />
      </BrowserView>

      <MobileView>
        <MobileDatePicker
          title={(
            <Button
              color='blue'
              variant='link'
              onClick={handleSetToday}
            >
              Today
            </Button>
          )}
          visible={mobileVisible}
          onClose={() => {
            setMobileVisible(false)
          }}
          onConfirm={handleOnValueChange}
          value={props.value ? (props.value as DateTime).toJSDate() : null}
          confirmText='Confirm'
          cancelText='Close'
        />
        <LuxonDatePicker
          {...props}
          onClick={() => setMobileVisible(true)}
          popupStyle={{display: 'none'}}
          inputReadOnly
        />
      </MobileView>
    </>
  )
}
